import { ACTIONS_FROM_WHITE_LABEL } from '../../constants';


export const setCustomImages = (whiteLabelEnabled, imageFormat, login, header, about) => ({
   type: ACTIONS_FROM_WHITE_LABEL.SET_CUSTOM_IMAGES,
   whiteLabelEnabled,
   imageFormat,
   login,
   header,
   about
})


// WEBPACK FOOTER //
// ./src/redux/actions/A_actions_from_white_label.js